import { createLucideIcon } from "lucide-react";

export const Remove = createLucideIcon(
    "Remove",
    [
        [
            "path",
            {
                d: "M20 12L4 12",
                key: "a4gsml",
            },
        ],
    ],
);
